import { render, staticRenderFns } from "./RelevantContents.vue?vue&type=template&id=434752b5&"
import script from "./RelevantContents.vue?vue&type=script&lang=js&"
export * from "./RelevantContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports